import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from 'gatsby'
import {
  Box,
  Container,
  Typography,
} from '@material-ui/core'
import * as Accessa from 'accessa'
import { useTranslation } from 'react-i18next'
import Hero from './Hero'

const toLists = (xs) =>
  Array.isArray(xs)
    ? xs.map(({ title, relativePath }) => ({
        listItemText: title,
        onClick: () => navigate(relativePath),
      }))
    : null

const ArchiveLayoutJobs = ({
  data: { contentfulArchive, allContentfulJob },
}) => {
  const { t } = useTranslation('titles')
  return (
    <Box pt={5} pb={5}>
      <Hero {...contentfulArchive} />
      <Container>
        <Typography variant="h2">
          {t('labels:openings')}
        </Typography>
        <Accessa.Lists.Archer
          underline
          lists={toLists(allContentfulJob.nodes)}
        />
      </Container>
    </Box>
  )
}

ArchiveLayoutJobs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
}

export default ArchiveLayoutJobs
